var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-content", on: { click: _vm.closeCalendar } },
    [
      _c("OrderInvoicesBlock"),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-body" }, [
          _c(
            "form",
            {
              staticClass: "fs-12",
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.search(1)
                },
              },
            },
            [
              _c("SearchFilter", {
                ref: "searchFilter",
                attrs: {
                  page: (_vm.paginator && _vm.paginator.current_page) || 1,
                  search: _vm.search,
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-right" },
                [
                  _c(
                    "vue-ladda",
                    {
                      attrs: {
                        "button-class": "btn btn-info",
                        type: "submit",
                        "data-style": "zoom-in",
                        loading: _vm.loading,
                      },
                    },
                    [_vm._v("Поиск\n            ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("pulse-loader", {
        staticClass: "text-center",
        attrs: { loading: _vm.loading, color: _vm.loadingColor },
      }),
      _vm._v(" "),
      !_vm.loading && _vm.searchRecordsShow
        ? _c("div", { staticClass: "card" }, [
            _c(
              "div",
              { staticClass: "card-body" },
              [
                !_vm.records || !_vm.records.length
                  ? [_c("h4", [_vm._v("Препаратов не найдено")])]
                  : [
                      _c(
                        "div",
                        { staticClass: "flex justify-content-between" },
                        [
                          _vm.paginator
                            ? _c(
                                "div",
                                [
                                  _c("paginate", {
                                    attrs: {
                                      "page-count": _vm.paginator.last_page,
                                      "page-range": 10,
                                      "margin-pages": 2,
                                      "click-handler": _vm.search,
                                      "prev-text": "&laquo",
                                      "next-text": "&raquo",
                                      "container-class": "pagination",
                                      "prev-class": "page-item",
                                      "prev-link-class": "page-link",
                                      "page-class": "page-item",
                                      "page-link-class": "page-link",
                                      "next-class": "page-item",
                                      "next-link-class": "page-link",
                                      "active-class": "active green_btn",
                                    },
                                    model: {
                                      value: _vm.paginator.current_page,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.paginator,
                                          "current_page",
                                          $$v
                                        )
                                      },
                                      expression: "paginator.current_page",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _c("DrugsList", {
                        ref: "drugsList",
                        attrs: {
                          getActiveDrug: (drugData) =>
                            this.getActiveDataFromSite(drugData),
                          drugLinks: _vm.drugLinks,
                          records: _vm.records,
                          fixedDates: true,
                          hideBlocks: { priceEdit: true },
                          drugsOrdered: _vm.ordered,
                          invoices: _vm.invoices,
                          freezeInvoices: _vm.freezeInvoices,
                          ordersStat: _vm.ordersStat,
                          soldData: _vm.soldData,
                          storeDrugData: _vm.storeDrugData,
                          profitCalculation: {
                            ..._vm.$refs.searchFilter.profitCalculation,
                            countryId:
                              +_vm.$refs.searchFilter.filter.type === 4
                                ? _vm.$refs.searchFilter.filter.searchData
                                : null,
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex justify-content-between" },
                        [
                          _vm.paginator
                            ? _c(
                                "div",
                                [
                                  _c("paginate", {
                                    attrs: {
                                      "page-count": _vm.paginator.last_page,
                                      "page-range": 10,
                                      "margin-pages": 2,
                                      "click-handler": _vm.search,
                                      "prev-text": "&laquo",
                                      "next-text": "&raquo",
                                      "container-class": "pagination",
                                      "prev-class": "page-item",
                                      "prev-link-class": "page-link",
                                      "page-class": "page-item",
                                      "page-link-class": "page-link",
                                      "next-class": "page-item",
                                      "next-link-class": "page-link",
                                      "active-class": "active green_btn",
                                    },
                                    model: {
                                      value: _vm.paginator.current_page,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.paginator,
                                          "current_page",
                                          $$v
                                        )
                                      },
                                      expression: "paginator.current_page",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      ),
                    ],
              ],
              2
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }